export default "__VITE_ASSET__DnhKbYdL__"